import React from 'react'
import { Routes, Route } from 'react-router-dom'
import LeaderboardNew from '../Pages/Leaderboard/LeaderboardNew'

const LeaderboardRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path='/' element={<LeaderboardNew />}>
        <Route path=':boardId' element={<LeaderboardNew />} />
      </Route>
    </Routes>
  )
}

export default LeaderboardRoutes
